"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppInstanceResolver = void 0;
const tslib_1 = require("tslib");
const WixSdkAdapter_1 = require("./WixSdkAdapter");
class AppInstanceResolver {
    constructor(params) {
        this.destroyed = false;
        this.destroy = () => {
            var _a;
            this.appInstance = null;
            (_a = this.unlistenAppInstanceChange) === null || _a === void 0 ? void 0 : _a.call(this);
            this.unlistenAppInstanceChange = null;
            this.destroy = this.revalidate = () => {
                throw new Error(`AppInstanceResolver was already destroyed`);
            };
            this.destroyed = true;
        };
        this.isDestroyed = () => {
            return this.destroyed;
        };
        this.wixSdkAdapter = (params === null || params === void 0 ? void 0 : params.wixSdkAdapter) || new WixSdkAdapter_1.WixSdkAdapter();
        this.appInstance = (params === null || params === void 0 ? void 0 : params.appInstance) || this.wixSdkAdapter.getAppInstanceFromQuery();
        if ((params === null || params === void 0 ? void 0 : params.revalidateAppInstance) || this.wixSdkAdapter.isRevalidateAppInstanceAvailable()) {
            const revalidate = (params === null || params === void 0 ? void 0 : params.revalidateAppInstance) || this.wixSdkAdapter.revalidateAppInstance;
            this.revalidate = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                const newAppInstance = yield revalidate();
                this.appInstance = newAppInstance;
                return newAppInstance;
            });
        }
        if (this.wixSdkAdapter.isAppInstanceChangeTrackable()) {
            this.unlistenAppInstanceChange = this.wixSdkAdapter.listenAppInstanceChange((newAppInstance) => {
                this.appInstance = newAppInstance;
            });
        }
    }
}
exports.AppInstanceResolver = AppInstanceResolver;
//# sourceMappingURL=AppInstanceResolver.js.map